import type { CandidateStatus, CandidateStatusFilter } from '../../../types/aiRecruiter';

export type CandidateBadgeStatus = CandidateStatusFilter | CandidateStatus;

/**
 * Опции фильтра «Статус кандидата» на странице «Диалоги».
 *
 * REL-17: статусы фазы рассылки не показываются в фильтре диалогов.
 */
export const CANDIDATE_STATUS_OPTIONS: Array<{ value: CandidateStatusFilter; label: string }> = [
  { value: 'CONTACTED', label: 'Контакт установлен' },
  { value: 'AI_APPROVED', label: 'Одобрен ИИ' },
  { value: 'AI_REJECTED', label: 'Отклонён ИИ' },
  { value: 'FINALIST', label: 'Финалист' },
  { value: 'DECLINED', label: 'Отказался' },
  { value: 'APPROVED', label: 'Одобрен' },
  { value: 'REJECTED', label: 'Отклонён' },
];

/** Лейбл-маппинг для бейджа кандидата. */
export const CANDIDATE_STATUS_LABEL: Record<CandidateBadgeStatus, string> = {
  PENDING: 'Ожидает',
  SENDING: 'Отправляется',
  CONTACTED: 'Контакт установлен',
  SKIPPED: 'Пропущен',
  ERROR: 'Ошибка',
  QUALIFIED: 'Одобрен',
  AI_APPROVED: 'Одобрен ИИ',
  AI_REJECTED: 'Отклонён ИИ',
  FINALIST: 'Финалист',
  DECLINED: 'Отказался',
  APPROVED: 'Одобрен',
  REJECTED: 'Отклонён',
};

export const CANDIDATE_STATUS_BADGE_CLASS: Record<CandidateBadgeStatus, string> = {
  PENDING: 'bg-yellow-50 text-yellow-700 border border-yellow-200',
  SENDING: 'bg-yellow-50 text-yellow-700 border border-yellow-200',
  CONTACTED: 'bg-blue-50 text-blue-700 border border-blue-200',
  SKIPPED: 'bg-gray-100 text-gray-500 border border-gray-300',
  ERROR: 'bg-red-50 text-red-700 border border-red-200',
  QUALIFIED: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  AI_APPROVED: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  AI_REJECTED: 'bg-red-50 text-red-700 border border-red-200',
  FINALIST: 'bg-green-50 text-green-700 border border-green-200',
  DECLINED: 'bg-gray-100 text-gray-500 border border-gray-300',
  APPROVED: 'bg-sky-50 text-sky-700 border border-sky-200',
  REJECTED: 'bg-red-50 text-red-700 border border-red-200',
};

/**
 * Минимально-достаточный срез полей диалога для отображения бейджа.
 *
 * TASKNEIROKLYUCH-771: после удаления resolveDialogCandidateStatus поля
 * lastIntent/closureReason перестали читаться отсюда — финальный бейдж
 * собирается только из dialogStatus (если есть) или candidateStatus. Если в
 * будущем понадобится разруливать бейдж по lastIntent — добавляйте поле
 * заново вместе с реальным consumer'ом, не «про запас» (иначе IntelliSense
 * подсказывает мёртвые поля и кто-то начинает на них опираться).
 */
export interface DialogCandidateStatusInput {
  candidateStatus?: CandidateBadgeStatus | null;
  skipReason?: string | null;
}
